// react
import React from "react";
import { connect } from "react-redux";

// components
import Button from "../../../../components/Button";
import EmployeePicker from "../../../../components/EmployeePicker/compatibility";

// actions
import { changePage, changePageValue, launchWorkflow } from "../actions";

// selectors
import { getAppWidth } from "../../../../selectors/app";
import { getIsRequesting } from "../../../../selectors/requests";
import { getHasManagerAssigned, getManagerFallbackValue } from "../selectors";

import PropTypes from "../../../../lib/prop-types";

class FinishingStep extends React.Component {
	static propTypes = {
		updateManagerFallback: PropTypes.func.isRequired,
		launchWorkflow: PropTypes.func.isRequired,
		changePage: PropTypes.func.isRequired,
		hasManagerAssigned: PropTypes.bool.isRequired,
		isRequesting: PropTypes.bool.isRequired,
		appWidth: PropTypes.number.isRequired,
		managerFallback: PropTypes.ajaxValue.isRequired,
		onBeforeLaunch: PropTypes.func,
		onLaunchFailed: PropTypes.func,
	};

	static defaultProps = {
		onBeforeLaunch: () => {},
		onLaunchFailed: () => {},
	};

	componentDidMount() {}

	goBack = () => {
		this.props.changePage(2);
	};

	handleLaunch = async () => {
		this.props.onBeforeLaunch();
		const succeeded = await this.props.launchWorkflow();
		if (!succeeded) {
			this.props.onLaunchFailed();
		}
	};

	render() {
		const { appWidth, isRequesting, hasManagerAssigned, managerFallback } = this.props;

		return (
			<section className="pt-2.5 pb-[120px]" style={{ width: appWidth }}>
				<div className="mb-2.5 text-center text-xl leading-[30px] font-bold text-neutral-6 uppercase">
					Launching
				</div>

				<div className="mx-auto mt-5 w-[440px]">
					{hasManagerAssigned ? (
						<div className="text-sm text-neutral-8">
							<div className="text-base font-semibold">Assign a Backup Manager</div>
							<div className="mt-1.5 text-[13px] leading-5 font-normal text-neutral-5">
								Your workflow includes assignments for an employee&apos;s manager. In the event that any
								employee selected for this workflow does not have a manager, please assign a backup
								employee that will be assigned any manager to-dos or signature requests for only those
								employees currently without an assigned manager.
							</div>

							<div className="mt-2.5 w-[300px]">
								<EmployeePicker onChange={this.props.updateManagerFallback} value={managerFallback} />
							</div>
						</div>
					) : (
						""
					)}

					<div className="relative mt-[30px]">
						<Button
							isHollow={true}
							className="button absolute top-0 left-0"
							onClick={this.goBack}
							style={{ width: "170px" }}
						>
							Back
						</Button>
						<Button
							color="green"
							className="button absolute top-0 right-0"
							isRequesting={isRequesting}
							onClick={this.handleLaunch}
							style={{ width: "170px" }}
						>
							Launch Workflow
						</Button>
					</div>
				</div>
			</section>
		);
	}
}

const mapStateToProps = (state) => ({
	appWidth: getAppWidth(state) - 50,
	hasManagerAssigned: getHasManagerAssigned(state),
	managerFallback: getManagerFallbackValue(state),
	isRequesting: getIsRequesting(state, "WORKFLOWS:WORKFLOW.LAUNCH"),
});

const mapDispatchToProps = (dispatch) => ({
	launchWorkflow: () => dispatch(launchWorkflow()),
	changePage: (pageNumber) => dispatch(changePage(pageNumber)),
	updateManagerFallback: (value) => dispatch(changePageValue(["managerFallbackUser"], value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinishingStep);
